import { createContext, useContext } from 'react';

const EarlyAccessContext = createContext(() => {});

export const useEarlyAccess = () => useContext(EarlyAccessContext);
export default EarlyAccessContext;
